export type ServerEnvironment = "local" | "dev" | "qa" | "prod";

export const isDevelopmentEnvironment = (env: ServerEnvironment): boolean => {
  return env === "dev";
};
